import { render, staticRenderFns } from "./Page032.vue?vue&type=template&id=c4f68e3c&scoped=true&"
import script from "./Page032.vue?vue&type=script&lang=js&"
export * from "./Page032.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f68e3c",
  null
  
)

export default component.exports